module.exports = __webpack_public_path__ + "static/media/need-weight.6b230bbc.jpg";